import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setRoute('shipment_carrier_summary_list');
